import type { SVGProps } from 'react';

// oxlint-disable-next-line sorare/no-restricted-paths
import { useIntlContext } from '#src/contexts/intl/index.ts';
import { playerUnavailability } from '#src/lib/glossary.ts';

type SVGRProps = {
  title?: string;
  titleId?: string;
};

export const Injured = ({
  title,
  titleId = 'injured',
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps) => {
  const { formatMessage } = useIntlContext();
  const i18nTitle = title ?? formatMessage(playerUnavailability.injuryTitle);

  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 16 16"
      fill="none"
      aria-labelledby={titleId}
      {...props}
    >
      {i18nTitle ? <title id={titleId}>{i18nTitle}</title> : null}
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16 15H0V12L7 0H9L16 12V15Z"
        fill="#F0CE1D"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7 4H9V9H7V4ZM7 11H9V13H7V11Z"
        fill="#101010"
      />
    </svg>
  );
};
